module.exports = __webpack_public_path__ + "img/5.1df7da08.jpg";